import React from 'react';

/* eslint-disable react/prop-types */
export default function ({ color }) {
  // viewBox="0 0 18 18"
  return (
    <>
      <path
        fill={color}
        d="M8.846 17.997a.475.475 0 0 1-.167-.03C-1.728 14.26.12 3.683.14 3.576c.036-.2.19-.357.386-.397 3.077-.653 5.71-1.67 8.057-3.106a.508.508 0 0 1 .524 0c2.867 1.76 5.49 2.776 8.017 3.1.213.026.386.19.426.403.02.103 1.84 10.25-8.52 14.387a.516.516 0 0 1-.187.037l.004-.003ZM1.072 4.083C.845 5.819.305 13.806 8.836 16.96c8.46-3.484 8.01-11.1 7.787-12.847-2.477-.38-5.03-1.374-7.78-3.027-2.29 1.363-4.84 2.347-7.774 3l.003-.003Z"
      />
      <path
        fill={color}
        d="M8.842 11.173c-.603 0-1.093-.43-1.093-.957a.547.547 0 0 0-1.093 0c0 .954.696 1.754 1.636 1.98v.367a.547.547 0 0 0 1.094 0v-.367c.94-.226 1.637-1.026 1.637-1.98 0-1.13-.98-2.046-2.184-2.046-.603 0-1.093-.43-1.093-.957 0-.527.49-.957 1.093-.957s1.093.43 1.093.957a.547.547 0 0 0 1.094 0c0-.954-.697-1.754-1.637-1.98v-.367a.547.547 0 0 0-1.093 0v.367c-.94.226-1.637 1.026-1.637 1.98 0 1.13.98 2.047 2.183 2.047.604 0 1.094.43 1.094.956 0 .527-.49.957-1.094.957Z"
      />
    </>
  );
}
